import React from 'react';
import { YELLOW } from '../const';

const SVG = ({ style = {}, color = YELLOW, width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={style} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g>
      <circle cx="50" cy="50" r="46" fill="transparent" stroke={color} strokeWidth={8} />
      <rect x="35" y="30" width="9" height="38" fill={color} />
      <rect x="56" y="30" width="9" height="38" fill={color} />
    </g>
  </svg>
);

export default SVG;
